<template>
  <div>
    <!-- <div id="publish" v-if="active===1" @click="switchStyle">
      <i class="iconfont icon-fenbupailie" v-show="newStyle"></i>
      <i class="iconfont icon-sigongge" v-show="!newStyle"></i>
    </div> -->
    <div class="tabs-wrapper">
      <van-tabs class="tabs" v-model="active" :line-width="36" @click="redirect">
        <van-tab title="圈子"></van-tab>
        <van-tab title="资讯"></van-tab>
        <van-tab title="学堂"></van-tab>
      </van-tabs>
    </div>
    <div class="viwe-wrapper">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs } from "vant";
import { mapMutations } from "vuex";
import { getToken, setToken } from "@/utils/auth";

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },

  data() {
    return {
      active: 0,
      newStyle: false,
    };
  },

  created() {
    setToken(window.location.search.split('=')[1])
    let paths = ["/wxapp/circle/all", "/wxapp/news", "/wxapp/school"];
    if(paths.indexOf(this.$route.path)>-1) {
      this.active = paths.indexOf(this.$route.path)
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if(from.path.indexOf('/article') === -1 && from.path!=='/') {
        vm.active = 0
      }
    })
  },

  methods: {
    redirect(index) {
      let paths = ["/wxapp/circle/all", "/wxapp/news", "/wxapp/school"];
      this.$router.replace(paths[index]);
    },
    switchStyle() {
      // this.newStyle = !this.newStyle;
      // this.controlStyle(this.newStyle);
    },
    ...mapMutations({
      // controlStyle: "WXAPP_STYLE"
    })
  },
};
</script>

<style lang="less" scoped>
#publish {
  position: fixed;
  top: 12px;
  right: 20px;
  z-index: 999;
  .iconfont {
    font-size: 18px;
    color: black;
  }
}
.iconfont {
  font-size: 22px;
  color: black;
}
.tabs-wrapper {
  padding: 0 25vw 10px;
  background-color: #fff;
  border-bottom: 1px solid #f3f3f3;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 996;
}
.viwe-wrapper {
  margin-top: 55px;
}
/deep/.van-hairline--top-bottom::after {
  border-width: 0 0;
}
/deep/.van-tab {
  font-size: 16px;
  color: #2b2b2b;
}
/deep/.van-tab--active {
  color: #e9aea8;
}
/deep/.van-tabs__line {
  background-color: #e9aea8;
}
</style>